/**
 * Tracking this outside of normal React flow
 * as we can't guarantee that any component
 * doesn't rerender.
 *
 * This is a partial External Store. Implementing it fully
 * with no consumer seems like a recipe for unneeded carrying
 * cost.
 *
 * If/when we have have usecases that need to subscribe here
 * we can move this to a full external store by implements `subscribe`
 *  and `getSnapshot`. (breadcrumbs is a potential usecase)
 *  https://react.dev/reference/react/useSyncExternalStore
 */
const urls: string[] = [];

/**
 * Append a url to the history.
 * @param url
 * @returns true if the url was added, false if it already existed.
 */
export const recordUrl = (url: string) => {
  if (urls.length === 0 || urls[urls.length - 1] !== url) {
    urls.push(url);
    // notifyAll();
    return true;
  }
  return false;
};

export const clearHistory = () => {
  urls.length = 0;
  // notifyAll();
};

// const notifyAll = () => listeners.forEach((x) => x());
// const listeners: Set<() => void> = new Set();

// export const subscribe = (listener: () => void) => {
//   listeners.add(listener);
//   return () => listeners.delete(listener);
// };

export const getSnapshot = () => [...urls];
